<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" persistent max-width="500px">
      <v-card class="px-3">
        <v-card-title primary-title class="title">User Form</v-card-title>
        <v-card-text class="pa-0">
          <v-alert outline type="error" :value="registerFailed">Could not register</v-alert>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    single-line
                    label="Name"
                    v-model="value.name"
                    :rules="[requiredRule]"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    label="Email"
                    type="email"
                    v-model="value.email"
                    :rules="[requiredRule,emailRule]"
                    required
                    single-line
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field label="Phone" v-model="value.phone" single-line></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :rules="[requiredRule, passwordRule]"
                    label="Password"
                    min="6"
                    :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    v-model="value.password"
                    single-line
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    multiple
                    chips
                    small-chips
                    dense
                    :items="rolesList"
                    v-model="value.roles"
                    label="Roles"
                    single-line
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-textarea v-model="value.notes" label="Notes about user" rows="3"></v-textarea>
                </v-flex>
                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="show = false;">Cancel</v-btn>

                  <v-btn
                    class="mx-0"
                    :loading="loading"
                    color="primary"
                    @click="submit"
                    :disabled="!valid"
                  >Register</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "register",
  props: {
    visibility: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      registerFailed: false,
      loading: false,
      valid: true,
      e1: true,

      requiredRule: v => !!v || "This field is required.",
      passwordRule: v => !(v && v.length < 6) || "Greater than 6 characters.",
      emailRule: v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Email must be valid.",

      rolesList: [
        "admin",
        "doctor",
        "pharmacy",
        "laboratory",
        "reception",
        "procedure",
        "finance"
      ]
    };
  },

  computed: {
    registerFailedFalse() {
      return this.email + this.passwrod;
    },
    show: {
      get() {
        return this.visibility;
      },
      set(value) {
        this.loading = false;
        this.$refs.form.reset();
        this.$emit("update:visibility", value);
      }
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.axios
          .post("/api/users", this.value)
          .then(user => {
            this.show = false;
            this.$emit("registered", user);
            // this.$emit("update:value", {});
          })
          .catch(error => {
            this.loading = false;
            this.registerFailed = true;
          });
      }
    }
  },
  watch: {
    registerFailedFalse() {
      this.registerFailed = false;
    }
  }
};
</script>